import { Entity, Input, Var } from "addeus-common-library/stores/firestore";
import { Collection } from "addeus-common-library/stores/firestore/collection";
import moment from "moment-with-locales-es6";

export enum SocialPostStatus {
    Programmed = "Programmed",
    Publishing = "Publishing",
    Published = "Published",
    Error = "Error",
    Waiting = "Waiting",
}

@Collection({
    namespace: "SocialPost",
})
export class SocialPost extends Entity {
    @Var(moment)
    publishedAt?: moment;

    @Var(String)
    socialProfileId?: string;

    @Var(SocialPostStatus)
    status?: SocialPostStatus;

    @Var(String)
    error?: string;

    @Var(String)
    uid?: string;

    @Var(String)
    network?: string;

    @Var(String)
    @Input("textarea")
    caption: string | null = null;

    @Var(Array.of(String))
    medias: string[] = [];

    @Var(String)
    errorMessageClient: string = "";
}
